<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="knowledge-base-page">
        <!-- JUMBOTRON -->
        <div class="knowledge-base-jumbotron">
            <div class="knowledge-base-jumbotron-content lg:p-32 md:p-24 sm:p-16 py-8 rounded-lg mb-base">
                <h1 class="mb-1 text-white">Cobrança em Lote</h1>
                <p class="text-white">Verifique as informações abaixo</p>

            </div>
        </div>

        <!-- KNOWLEDGE BASE CARDS  -->
        <div class="vx-row">
                <div class="vx-col w-full" v-for="item in filteredKB" :key="item.id" @click="openLinkorUpload(item.id)">
                    <vx-card class="text-center cursor-pointer">
                        <img :src="require(`@/assets/images/pages/${item.graphic}`)" alt="graphic" width="180" class="mx-auto mb-4">
                        <h4 class="mb-2">{{ item.title.toUpperCase() }}</h4>
                        <small>{{ item.description }}</small>
                    </vx-card>
                </div>
                <div class="vx-col w-full">
                  <input type="file" accept=".csv" @change="handleFileUpload( $event )"/>
                </div>
                <div class="vx-col w-full">
                  <table v-if="parsed" style="width: 400px;">
                    <thead>
                        <tr>
                            <th v-for="(header, key) in content.meta.fields"
                                v-bind:key="'header-'+key">
                                {{ header }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, rowKey) in content.data"
                            v-bind:key="'row-'+rowKey">
                                <td v-for="(column, columnKey) in content.meta.fields"
                                    v-bind:key="'row-'+rowKey+'-column-'+columnKey">
                                        <input v-model="content.data[rowKey][column]"/>
                                </td>
                        </tr>
                    </tbody>
                </table>
              </div>
              <div class="vx-col w-full" v-if="parsed">
                  <div class="flex justify-center mt-base">
                      <vs-button id="button-load-more-posts" class="vs-con-loading__container" @click="loadContent(0)">Processar Cobrança</vs-button>
                  </div>
              </div>
            </div>
    </div>
</template>

<script>
import Papa from 'papaparse';

export default{
    data() {
        return {
            file: '',
            content: [],
            parsed: false,
            knowledgeBaseSearchQuery: '',
            kb: [
                { id: 1, title: 'Template', description: 'Baixe o template para a importação clicando aqui!', graphic: 'graphic-1.png' ,url: '/pages/knowledge-base/category'},
            ]
        }
    },
    computed: {
        filteredKB() {
            return this.kb.filter((item) => item.title.toLowerCase().includes(this.knowledgeBaseSearchQuery.toLowerCase()) || item.description.toLowerCase().includes(this.knowledgeBaseSearchQuery.toLowerCase()));
        }
    },
    methods: {
        parseFile(){
            Papa.parse( this.file, {
                header: true,
                skipEmptyLines: true,
                complete: function( results ){
                    this.content = results;
                    console.log(results.data);
                    this.parsed = true;
                }.bind(this)
            } );
        },
        handleFileUpload( event ){
            this.file = event.target.files[0];
            this.parseFile();
        },
        async cadastroDoc(id){
          this.$vs.loading.close();
          this.$vs.loading({
            type:'radius',
            text:'Cadastrando lista: '+id
          });

          await fetch(this.$store.state.API_URL + 'Operador/Cadastro/Usuario/Lote', {
              method: 'POST',
              headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
              body: "token="+localStorage.getItem("token")+"&nome_cliente="+this.nome_cliente+"&data_nascimento="+this.data_nascimento+"&sexo="+this.sexo+"&cpf="+this.cpf+"&telefone="+this.telefone+"&email="+this.email+"&cep="+this.cep+"&endereco="+this.endereco+"&numero="+this.numero+"&complemento="+this.complemento+"&cidade="+this.cidade+"&bairro="+this.bairro+"&estado="+this.estado+"&cc="+this.cc+"&cv="+this.cv+"&cvv="+this.cvv
          })
          .then((response) => response.text())
          .then((responseData) => {
              this.$vs.loading.close();

              var dados = JSON.parse(responseData);

              if(dados.done == true)
              {
                  this.$vs.notify({
                      title: 'Venda Operação: '+id,
                      text: dados.message,
                      time: 5000,
                      color: 'success',
                      iconPack: 'feather',
                      icon: 'icon-alert-circle'
                  })
              }
              else
              {
                  this.$vs.notify({
                      title: 'Error Operação: '+id,
                      text: dados.message,
                      time: 5000,
                      color: 'danger',
                      iconPack: 'feather',
                      icon: 'icon-alert-circle'
                  })
              }

          })
          .catch((error) => {
            this.$vs.notify({
                title: 'Error Operação: '+id,
                time: 5000,
                text: 'Tente novamente mais tarde!',
                color: 'danger',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
            })
          })

          setTimeout(() => {
            console.log(id);
            this.loadContent(id+1)
          }, 3000);
        },
        closeloading()
        {
          this.$vs.loading.close();
        },
        async loadContent(id)
        {


          //console.log(this.content['data'].length);
          if(id == this.content['data'].length)
          {
            this.$vs.loading.close();
            this.$vs.notify({
                title: 'Lote',
                text: 'Operações enviadas',
                time: 5000,
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
            })

          }
          if(id < this.content['data'].length)
          {
            await this.cadastroDoc(id);
            //this.$vs.loading.close();

            /*await fetch(this.$store.state.API_URL + 'Operador/Cadastro/Usuario/Lote', {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
                body: "token="+localStorage.getItem("token")+"&nome_cliente="+this.nome_cliente+"&data_nascimento="+this.data_nascimento+"&sexo="+this.sexo+"&cpf="+this.cpf+"&telefone="+this.telefone+"&email="+this.email+"&cep="+this.cep+"&endereco="+this.endereco+"&numero="+this.numero+"&complemento="+this.complemento+"&cidade="+this.cidade+"&bairro="+this.bairro+"&estado="+this.estado+"&cc="+this.cc+"&cv="+this.cv+"&cvv="+this.cvv
            })
            .then((response) => response.text())
            .then((responseData) => {
                this.$vs.loading.close();

                var dados = JSON.parse(responseData);

                if(dados.done == true)
                {
                    this.$vs.notify({
                        title: 'Venda',
                        text: dados.message,
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }
                else
                {
                    this.$vs.notify({
                        title: 'Error',
                        text: dados.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }

            })
            .catch((error) => {
              this.$vs.loading.close();
              this.$vs.notify({
                  title: 'Error',
                  text: 'Tente novamente mais tarde!',
                  color: 'danger',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
              })*/

          }


        }
    },
    components: {}
}
</script>

<style lang="scss">
.knowledge-base-jumbotron-content {
    background-image: url('../../assets/images/pages/knowledge-base-cover.jpg');
    background-size: cover;
}
</style>
